export default "__VITE_ASSET__DBKT7sX2__"